// extracted by mini-css-extract-plugin
export default {"wrapper":"MediatorPolling_wrapper__PZR3e"};